import React from 'react';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import HelpButton from '../../../../components/HelpButton';
import PbxVirtualOperator from './PbxVirtualOperator';
const PbxVirtualOperatorStatisticsList = React.lazy(() =>
  import('./PbxVirtualOperatorStatisticsList')
);

const PbxVirtualOperatorStatisticsPage = (props) => (
  <PbxVirtualOperator scrolling>
    <div className="text-right">
      <HelpButton fileName="virtual-operator-statistics-list" />
    </div>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <PbxVirtualOperatorStatisticsList {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </PbxVirtualOperator>
);

export default PbxVirtualOperatorStatisticsPage;
